<template>
    <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path
            d="M5.38224 8.1875C5.51285 7.96151 5.83937 7.9617 5.97013 8.1875L10.9672 16.8428C11.0975 17.069 10.9344 17.3515 10.6733 17.3516H0.680092C0.418881 17.3516 0.255669 17.069 0.386147 16.8428L5.38224 8.1875Z"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="0.678788" />
        <path
            d="M13.3158 17.0664C13.1852 17.2924 12.8587 17.2922 12.7279 17.0664L7.73087 8.41113C7.60056 8.18493 7.7637 7.90238 8.02482 7.90234L18.018 7.90234C18.2792 7.90234 18.4424 8.1849 18.3119 8.41113L13.3158 17.0664Z"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="0.678788" />
    </svg>
</template>
